import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { ISelect } from 'app/shared/models/select.model';
import { InabilityService } from 'app/views/appviews/request/inability.service';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HolidayService } from 'app/views/appviews/request/holiday.service';
import { SecurityService } from '../../../shared/services/security.service';
import { WorkLeaveService } from 'app/views/appviews/request/workLeave.service';
import { AppConfig } from 'app/app.config';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IMyDateModel } from 'angular-mydatepicker';
import { LiquidationService } from 'app/views/appviews/liquidation.service';

@Component({
    selector: 'app-modal-employees',
    templateUrl: './modal-employees.template.html',
    styleUrls: ['./modal-employees.style.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ModalEmployeesComponet implements OnInit {
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Retorno a pantalla padre */
    public onClose: Subject<IDtoEmployee>;
    /**Catalogos */
    private catalogZones: Observable<ISelect[]>;
    private listEmployees: IDtoEmployee[]
    private listEmployeesTemp: IDtoEmployee[]
    private search: string;
    private module: string;
    private employeeIds: number[];
    /**Securty */
    private showRoles: any;
    private employeeIniId: string;
    private pickerOptions = {
        dateFormat: 'dd.mm.yyyy',
        dateRange: false
    }
    private init = new Date();
    private end = new Date();
    @ViewChild(DatatableComponent, { static: false }) tableEmployees: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private spinner: NgxSpinnerService
        , private inabilityService: InabilityService
        , private holidayService: HolidayService
        , private securityService: SecurityService
        , private dismissalService: WorkLeaveService
        , private configGeneral: AppConfig
        , private employeeService: EmployeeService
        , private liquidationService: LiquidationService) {
        this.init.setDate(this.init.getDate() - 5);
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
        }
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.getListEmployeeActive();
        this.onClose = new Subject();
    }

    // private onDateChangedInit(event: IMyDateModel): void {
    //     this.init = event.singleDate; // Guardar la fecha seleccionada en la variable
    //   }
    //   private onDateChangedEnd(event: IMyDateModel): void {
    //     this.end = event.singleDate; // Guardar la fecha seleccionada en la variable
    //   }
    private getListEmployeeActive(): void {
        this.spinner.show();
        if (this.module == 'Retroactives') {
            this.employeeService.getListEmployeesByIds(this.employeeIds).subscribe((res) => {
                this.listEmployees = res;
                this.listEmployeesTemp = res;
                this.spinner.hide();
            });
        } else if (this.module == 'Liquidation') {
            let i = this.configGeneral.dateFormat(this.init, 'yyyy-mm-dd')
            let e = this.configGeneral.dateFormat(this.end, 'yyyy-mm-dd')
            this.employeeService.getListDismissalEmployeesByBossId(i, e).subscribe((res) => {
                this.listEmployees = res;
                this.listEmployeesTemp = res;
                this.spinner.hide();
            });
        } else {
            this.inabilityService.getListActiveEmployeesByBossId(this.employeeIniId).subscribe((res) => {
                this.listEmployees = res;
                this.listEmployeesTemp = res;
                this.spinner.hide();
            });
        }
    }
    private getListDismissalEmployees(): void {
        this.spinner.show();
        if (this.module == 'Liquidation') {
            let i = this.configGeneral.dateFormat(this.init, 'yyyy-mm-dd')
            let e = this.configGeneral.dateFormat(this.end, 'yyyy-mm-dd')
            this.employeeService.getListDismissalEmployeesByBossId(i, e).subscribe((res) => {
                this.listEmployees = res;
                this.listEmployeesTemp = res;
                this.spinner.hide();
            });
        }
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        // const temp = this.listEmployeesTemp.filter((x: any) => x.employeeName.toLowerCase().startsWith(val));
        //|| x.employeeMarkName.toLowerCase().startsWith(val))
        // || x.zone.toLowerCase().startsWith(val));
        const temp = this.listEmployeesTemp.filter(function (d) {
            return d.employeeName.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.listEmployees = temp;
        this.tableEmployees.offset = 0;
    }
    private navigateTo(row: IDtoEmployee): void {
        this.onClose.next(row);
        this.bsModalRef.hide();
    }
    private getEmployeeData(row: IDtoEmployee): void {
        this.spinner.show();
        if (this.module == 'Liquidation') {
            this.employeeService.getEmployeeDataDismissalById(Number(row.requisitionId)).subscribe((res) => {
                let employee = res;
                this.spinner.hide();
                this.hasLiquidation(employee)
            });
        } else {
            this.holidayService.getEmployeeData(row.id.toString()).subscribe((res) => {
                let employee = res.data as IDtoEmployee;
                this.spinner.hide();
                this.hasDismissalWaiting(employee)
                // this.onClose.next(employee);
                // this.bsModalRef.hide();
            });
        }
    }
    private hasDismissalWaiting(employee: IDtoEmployee): void {
        this.spinner.show();
        this.dismissalService.hasDismissalWaiting(employee.id).subscribe((res) => {
            let value = res.data;
            this.spinner.hide();
            if (<any>value == true) {
                this.configGeneral.newToast('Error', 'El empleado seleccionado tiene actualmente una baja en espera. Seleccione otro empleado', 'error');
            } else {
                this.onClose.next(employee);
                this.bsModalRef.hide();
            }
        });
    }
    private hasLiquidation(employee: IDtoEmployee): void {
        this.spinner.show();
        this.liquidationService.hasLiquidation(employee.id, employee.requisitionId).subscribe((res) => {
            let value = res.data;
            this.spinner.hide();
            if (<any>value == true) {
                this.configGeneral.newToast('Error', 'El empleado seleccionado ya tiene una liquidación. Seleccione otro empleado', 'error');
            } else {
                this.onClose.next(employee);
                this.bsModalRef.hide();
            }
        });
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
